import { Component, OnInit, Input, ChangeDetectorRef, SimpleChanges, Output } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ExcessProtectService } from './excess.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfoService } from '../../services/user-info.service';
import { ExcessProtect } from 'src/app/model/quote/excessprotect/excessprotect.model';
import { environment } from '../../../environments/environment';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-excess-protect',
  templateUrl: './excess-protect.component.html',
  styleUrls: ['./excess-protect.component.css']
})

export class ExcessProtectComponent implements OnInit {
  authDetails = '';
  selectedIndex = 0;
  @Input() quote;
  fullDetailsTab = false;
  statementOfFactsTab = false;
  paymentDetails = false;
  submission = false;
  staticData;
  excessProtectOptions;
  apiModelObject;
  modelObject = new ExcessProtect();
  urlID = this.route.snapshot.params.id;
  quote_type: number = this.route.snapshot.params.quote_type ? this.route.snapshot.params.quote_type : 1;
  mtaFinancials: any = null;
  unlockedTabIndex: number = 0


  constructor(private excessProtectService: ExcessProtectService,
    private route: ActivatedRoute,
    private router: Router,
    private userInfoService: UserInfoService) {
  }

  ngOnInit() {
    this.userInfoService.getUserDetails();
    this.getAccessToken();
    this.getExcessProtectData();
    this.getExcessProtectOptionsList();
    // If editing an existing quote (ID present), unlock all tabs
    if (this.route.snapshot.params.id) {
      this.unlockedTabIndex = 2; // all tabs enabled
    }
  }

  getAccessToken() {
    const data = {
      client_id: environment.AMLINE_CLIENT_ID,
      client_secret: environment.AMLINE_CLIENT_SECRET,
      grant_type: environment.AMLINE_GRANT_TYPE,
      scope: environment.AMLINE_SCOPE,
    };
    this.excessProtectService.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
          }
        }
      );
  }

  getStaticData(response) {
    this.excessProtectService.getStaticData(response)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        }
      );
  }

  tabChanged(index: number) {
  }

  getExcessProtectData(id = '') {
    if (this.route.snapshot.params.id) {
      let quote_id = this.route.snapshot.params.id;
      let temp_modelObj = this.modelObject;
      if (id) {
        quote_id = id;
      }
      this.excessProtectService.getExcessProtectData(quote_id)
        .subscribe(
          (response: any) => {
            if (response.result) {
              // response.result.quote_data.quote_versions[0].amlin_data.data.attributes.application.vehicles.forEach((res) => {
              //   const drivers = [];
              //   if (res.drivers && res.drivers.length > 0) {
              //     res.drivers.forEach((d) => {
              //       drivers.push(d);
              //     });
              //     res.drivers = drivers;
              //   }

              // });

              this.apiModelObject = response.result.quote_data.quote_versions[0];
              this.modelObject = response.result.quote_data.quote_versions[0];

              if (response.result.quote_data.quote_versions[0].status == "referred") {
                this.router.navigate(['/excess-protect/quote-details/', this.route.snapshot.params.id]);
              }
            }
          }
        );
    }
  }

  modelObjectUpdated(data) {
    this.modelObject = null;
    this.modelObject = data;
    this.getExcessProtectData(data.id);

    // Unlock the next tab each time a tab saves
    if (this.selectedIndex >= this.unlockedTabIndex) {
      this.unlockedTabIndex = this.selectedIndex + 1;
    }
    this.selectedIndex += 1;
  }

  // Add this method to handle MTA financials updates
  onMtaFinancialsUpdated(mtaData: any) {
    this.mtaFinancials = mtaData;
  }
  /**
 * 
 * @param response 
 */

  public getExcessProtectOptionsList() {
    // GET UNIQUE ID FOR DRIVERS
    this.excessProtectService.getExcessProtectOptions()
      .subscribe(
        (response: any) => {
          if (response) {
            this.excessProtectOptions = response;
          }
        },
        (error) => { }
      );
  }
  isFleetActivated: boolean = false;
  is_fleet(event) {
    this.isFleetActivated = event;
  }

}
